import { GlobalStyle } from "./GlobalStylesViewController";

/** Hide the UserWay button when in use in a mobile view */
export const HideUserWayStyle = new GlobalStyle("userway_buttons_wrapper", { display: "none !important" });
